const semanticClassNames = {
    container: 'list-item-select__container',
};
export default semanticClassNames;
//# sourceMappingURL=ListItemSelect.semanticClassNames.js.map